// @flow
import { createAction } from 'redux-actions';

import { UPDATE_CAMERA_SETTINGS, CAMERA_SETTINGS_UPDATED } from './constants';

export const updateCameraSettings = createAction(UPDATE_CAMERA_SETTINGS);
export const cameraSettingsUpdated = createAction(CAMERA_SETTINGS_UPDATED);



// WEBPACK FOOTER //
// ./src/core/state/camera/actions.js